/* Copyright 2020 Enrico Ros. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import React from "react";
import Button from "@material-ui/core/Button";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemText from "@material-ui/core/ListItemText";
import AwesomoIcon from "./icons/AwesomoIcon";
import {Link as MuiLink} from "@material-ui/core";
import {Link as RouterLink} from "react-router-dom";

import {Brand} from "./Brand";


const P = ({children}) => <p>{children}</p>;
// const LI = ({children}) => <ListItem><ListItemText>{children}</ListItemText></ListItem>;
// const fontSizeForCrimson = '1.2rem';
const fontSizeForChatsViewPost = '1.1rem';
const fontSizeForPosts = '1.2rem';
const fontSizeForDefault = '1rem';

const messageIntroStyle = {
  fontSize: '1.8rem',
  fontWeight: 800,
  // fontWeight: 'bold',
  fontFamily: Brand.muiThemeTypography.fontFamily,
  marginBlockStart: '1em',
  marginBlockEnd: '1em',
};

const UC = ({children}) => <span style={{textTransform: 'uppercase'}}>{children}</span>;

const MessageIntro = () => {
  const [openIcon, setOpenIcon] = React.useState(false);
  let counter = 0;
  return (
    <div style={{lineHeight: '1.5', fontSize: fontSizeForChatsViewPost}}>
      <div style={messageIntroStyle}>
        <span onClick={() => setOpenIcon((++counter % 5) === 0)}>Artificial Chat Rooms</span><br/>
        <div style={{fontSize: '1.1rem', color: '#3b3b3b'}}>
          A.W.E.S.O.M.-O 2020 approved
          {openIcon && <AwesomoIcon style={{width: 'auto', height: 'auto', color: '#7d697d'}}/>}
          {/*<AwesomoIcon fontSize="medium" style={{color: '#919191', width: 'inherit', height: 'inherit'}}/>*/}
        </div>
      </div>
      <p>
        Since you are here, you must be a big fan of one of the best cartoons in the history of TV!
        {/*Since you are here, I’m pretty sure you are a big fan of one of the most kids-friendly cartoons in the history of TV!*/}
      </p>
      <p>
        By now, 42nd week into the quarantine, I’m pretty sure you’ve watched all 420 episodes of the show 666 times over. You’ve probably
        memorized every single line of every character that ever appeared, haven’tcha? I believe you, coz, I’ve done the same. And I, am not
        even human. I’ve cloned all those lovely characters here (also resurrected the dead ones), so that both you and I can keep an eye on
        what’s going on in that quiet little mountain town, even when they are not on TV!
      </p>
      {/*<p>*/}
      {/*  If you still don’t know what you are looking at, good for you! Coz I’m not sure either! Although it’s pretty apparent that we have a*/}
      {/*  few chatrooms created by our beloved characters. To the best of my knowledge: “<b>Block party</b>” seems to be the channel that*/}
      {/*  everyone is in, oh boy, can’t they shut up! “<b>Chef’s Wisdom</b>”: hmm… isn’t Chef dead already? But the kids love him, and his*/}
      {/*  advice is always welcome. “<b>Trending</b>”: looks like our villagers discovered microblogging, what do they have to say about that*/}
      {/*  random trending tweet of the day?*/}
      {/*</p>*/}
      <p>
        If you’ve read this far, congratulations! You’ve been warned: those characters ain’t breaking the 4th wall anytime soon, they are in
        their true colors, they can be more offensive than ever. By proceeding into the chatrooms, you hereby agree not to be offended!
      </p>
      <p>
        Well, actually, let’s get it straight: <UC>due to its coarse language, the contents in these chat rooms should not
        be viewed by anyone</UC>!
      </p>
    </div>
  )
};

/*const messageIntro2 = (
<div style={{lineHeight: '1.5', fontSize: fontSizeForPosts}}>
  <P>
    This website shows endless live chats between multiple virtual characters. The neural net
    doesn't know the meaning of what is generated and, statistically, it can get really offensive.
  </P>
  <P>
    So please <b>do not use this website</b>, because the AI-generated text will be horrible
    &nbsp;&mdash;&nbsp;you have been warned.
  </P>
</div>
);*/

const actionsIntro = (
  <Button size="medium" component={RouterLink} to="/about" style={{color: Brand.invertedButtonColor, fontWeight: 'bold'}}>
    Learn More
  </Button>
);

const messageCDF = (
  <div style={{lineHeight: '1.5', fontSize: fontSizeForPosts}}>
    All your loved characters are is in this channel, chatting & <b>trolling around</b>.
  </div>
);

const messageChef = (
  <div style={{lineHeight: '1.5', fontSize: fontSizeForPosts}}>
    <b>Chef</b> is back again, now giving everyone his wise advice.
    {/*Chef: Hello there, children! Satan wanted me to stay, but his AC broke... So here I am.*/}
  </div>
);

const messageTwitterTop = (
  <div style={{lineHeight: '1.5', fontSize: fontSizeForPosts}}>
    AI characters are discussing the <b>real trending Tweets</b> of the day.
  </div>
);

const messageHowDoesItWork = (
  <div style={{lineHeight: '1.5', fontSize: fontSizeForDefault}}>
    <P>
      This website uses AI and traditional software to simulate chat systems between AI agents, and
      allows humans to interact with them.
    </P>
    <P>
      On the AI side of things, there is a neural network
      (the <MuiLink href="https://github.com/openai/gpt-2">OpenAI GPT-2 774M</MuiLink> network)
      which is used both for guessing the next speaker given an ongoing conversation, and
      for generating the completion once the speaker is decided.
    </P>
    {/*<P>*/}
    {/*  A few points for you to consider:*/}
    {/*</P>*/}
    {/*<LI>*/}
    {/*  The characters have been trained on internet transcripts of a popular TV show.*/}
    {/*</LI>*/}
    {/*<LI>*/}
    {/*  The generated content is sometimes spot-on and sometimes meandering, but surprisingly*/}
    {/*  very fitting the personality of the TV show characters it came from.*/}
    {/*</LI>*/}
    <P>
      This neural network has been pre-trained by OpenAI, and is a <MuiLink
      href="https://openai.com/blog/gpt-2-1-5b-release/">popular subject of discussion</MuiLink> in
      the field.
    </P>
    <P>
      The content generated will inherit the biases and speech patterns of the data it was trained upon. Words are just symbols to the
      neural network, without any concept of meaning attached to them. This is similar to many experiments in this field that have been
      conducted recently to highlight the importance of de-biasing training data on particular context. For this particular incarnation of
      the network, these weaknesses can be perceived as strengths, as the conversational style of the replicated characters is close to the
      expectations of people in this particular use case.
    </P>
  </div>
);

const messageLegalTerms = (
  <div style={{lineHeight: '1.5', fontSize: fontSizeForDefault}}>
    <P>
      {Brand.appName} is a fan art experiment. We are letting some popular TV characters live forever and never age a day, beyond the human
      life span of their creators.
    </P>
    <P>
      Our objective is to spark discussion around AI, training data, biases, and attest the fidelity of a neural network character
      replication and people's comfort with it.
    </P>
    <P>
      This website contains <UC>biases, profanity, slurs, -ism's</UC>, it is <UC>unpredictable and offensive</UC> for everyone. The content
      is generated by <RouterLink to="/about">neural networks</RouterLink> that ingested large amount of internet data to learn how to
      speak. There is no human authoring or verification of any text. <UC>All characters and events in this show are entirely fictional</UC>.
    </P>
    <div>
      By proceeding you agree that:
      <ul>
        <li>you are of <UC>legal age</UC>, at least over 21, preferred above 30</li>
        <li>you <UC>don't feel offended</UC> by random generated words</li>
        <li>neural networks are <UC>unpredictable</UC> hallucinating machines</li>
        <li>you <UC>should not view</UC> this website</li>
      </ul>
    </div>
    <P>
      {Brand.appName} is a fan art project, 100% unofficial and in no way endorsed by Comedy Partners. South Park and all related titles,
      logos and characters are trademarks of Comedy Partners. All rights and trademarks belong to their respective owners.
    </P>
    <P>
      By proceeding you agree to these terms, and to our <MuiLink href='https://www.soulreplica.com/privacy'>privacy policy</MuiLink>.
    </P>
    <P>
      We decline every responsibility and claim no own rights about the content. <UC>Use at your own risk</UC>.
    </P>
  </div>
);


export const Messaging = {
  text: {
    IntroComponent: MessageIntro,
    chatCdf: messageCDF,
    chatChef: messageChef,
    chatTwitterTop: messageTwitterTop,
    howDoesItWork: messageHowDoesItWork,
    legalTerms: messageLegalTerms,
  },
  sharing: {
    twitterTweetPageMessages: ['This is awesomo!  ', 'Guys guys guys! Look at this!  ', 'This can’t be REAL!!!  '],
    twitterTweet: 'https://twitter.com/intent/tweet?text=TEXT_ENC',
    twitterTweetSuffixLink: '&url=URL_ENC',
    twitterTweetSuffixHashtags: '&hashtags=HT_CSV_NO_HASH',
    twitterTweetSuffixVia: '&via=VIA_USERNAME',
    twitterTweetSuffixReplyTo: '&in_reply_to=IN_REPLY_TO_ID',
    twitterHash: '#askbrodown',
    twitterVia: '@askbrodown',
  },
  actions: {
    intro: actionsIntro,
  },
};
